import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/ui/components/ui/card.tsx";
import { Progress } from "@/ui/components/ui/progress";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface KpiStatsSkeletonProps {
  title: string;
  icon?: React.ReactNode;
}

const KpiStatsSkeleton = ({ title, icon }: KpiStatsSkeletonProps) => {
  const { t } = useTranslation("machines");

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="flex justify-between items-start">
          <div className="flex items-center gap-2">
            {icon && <span className="text-muted-foreground">{icon}</span>}
            <div className="flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin text-primary" />
              <span className="text-muted-foreground">{t("kpiStats.loading")}</span>
            </div>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription>{title}</CardDescription>
        <div className="mt-2">
          <Progress value={65} className="h-1" />
        </div>
      </CardContent>
    </Card>
  );
};

export default KpiStatsSkeleton;
